import React from "react";

const TopSection = ({ title }) => {
  return (
    <div
      className={`h-20 bg-[#d0eff5] w-full mt-6 dark:bg-primary-darkBgSecondary`}
    >
      <div className="flex pt-6 text-white container items-center justify-center">
        <span className="font-semibold text-lg font-poppins text-default dark:text-white">
          {title}
        </span>
      </div>
    </div>
  );
};

export default TopSection;
